import {
  CmBaseTable,
  CmTableBodyRow,
  CmTd,
  ThProps,
} from '@/components/uiParts';
import { DeliveryAreaModal } from '@/pages/delivery/in-house/components/DeliveryAreaTable/DeliveryAreaModal';
import { useDeliveryAreaForm } from '@/pages/delivery/in-house/hooks/useDeliveryAreaForm';
import { AuthStoreDeliveryAreas } from '@/pages/delivery/in-house/types';
import { useDeliveryAreas } from '@/pages/delivery/in-house/useDeliveryAreas';

type Props = {
  authStoresDeliveryAreas: AuthStoreDeliveryAreas[];
};

export const DeliveryAreaTable: React.FC<Props> = ({
  authStoresDeliveryAreas,
}) => {
  const { handleDeliveryAreaUpdate } = useDeliveryAreas();

  const {
    isOpen,
    onClose,
    error,
    storesDeliveryAreas,
    handleAddDeliveryArea,
    handleDeleteDeliveryArea,
    handleDeliveryAreasDetail,
    handleUpdatePostalCodes,
    handleChangeName,
    handleChangePostalCode,
    handleChangeDeliveryFee,
    handleChangeDeliveryAsapDuration,
  } = useDeliveryAreaForm();

  const itemTableThs: ThProps[] = [
    {
      label: '拠点名',
      minWidth: '200px',
      position: 'left',
    },
    {
      label: '配達エリア名',
      minWidth: '100px',
      position: 'left',
    },
    {
      label: '郵便番号',
      minWidth: '120px',
      position: 'left',
    },
    {
      label: '配送手数料',
      minWidth: '120px',
      position: 'left',
    },
    {
      label: '最短配達時間',
      minWidth: '120px',
      position: 'left',
    },
  ];

  return (
    <>
      <CmBaseTable ths={itemTableThs}>
        {authStoresDeliveryAreas?.map((authStoreDeliveryAreas) => {
          const deliveryAreas = authStoreDeliveryAreas.delivery_areas || [];

          if (deliveryAreas.length === 0) {
            return (
              <CmTableBodyRow key={authStoreDeliveryAreas.auth_store_name}>
                <CmTd
                  onClick={() =>
                    handleDeliveryAreasDetail(authStoreDeliveryAreas)
                  }
                  color="blue.500"
                  maxWidth="240px"
                >
                  {authStoreDeliveryAreas.auth_store_name}
                </CmTd>
                <CmTd>未設定</CmTd>
                <CmTd colSpan={3} />
              </CmTableBodyRow>
            );
          }

          return deliveryAreas?.map((deliveryArea, index) => (
            <CmTableBodyRow
              key={index}
              borderTopWidth={'0'}
              borderBottomWidth={'0'}
            >
              <CmTd
                onClick={() =>
                  handleDeliveryAreasDetail(authStoreDeliveryAreas)
                }
                color="blue.500"
                maxWidth="240px"
              >
                {/* 配達エリアが複数の場合は、1つ目の配達エリアのみ表示 */}
                {index === 0 ? authStoreDeliveryAreas.auth_store_name : ''}
              </CmTd>
              <CmTd>{deliveryArea.name}</CmTd>
              <CmTd>{deliveryArea.postal_codes.join(', ')}</CmTd>
              <CmTd>{`¥${deliveryArea.delivery_fee}`}</CmTd>
              <CmTd>{`${deliveryArea.asap_duration} 分~`}</CmTd>
            </CmTableBodyRow>
          ));
        })}
      </CmBaseTable>

      <DeliveryAreaModal
        isOpen={isOpen}
        onClose={onClose}
        error={error}
        storesDeliveryAreas={storesDeliveryAreas as AuthStoreDeliveryAreas}
        handleDeliveryAreaUpdate={handleDeliveryAreaUpdate}
        handleAddDeliveryArea={handleAddDeliveryArea}
        handleDeleteDeliveryArea={handleDeleteDeliveryArea}
        handleUpdatePostalCodes={handleUpdatePostalCodes}
        handleChangeName={handleChangeName}
        handleChangePostalCode={handleChangePostalCode}
        handleChangeDeliveryFee={handleChangeDeliveryFee}
        handleChangeDeliveryAsapDuration={handleChangeDeliveryAsapDuration}
      />
    </>
  );
};
